import type { ReactNode } from 'react'

import { Box } from '@enechain/ecloud-designsystem'

type PageScrollAreaProps = {
  children: ReactNode
}

/**
 * スクロール所有の明示 (frontend-design-unification 設計書 §5.1)。
 * 内部: flex 1 + minHeight 0 + overflow auto (prop 化しない)。flex column 内で
 * 子が縮まずスクロールしない古典的落とし穴 (min-height:0) を隠す。
 * PageBody 直下で 1 ページ 1 箇所が原則。
 * 子は flex column の子として振る舞う。`flex:1` を持つ子 (48 コマ PlanTable 等) は
 * 残余高さに収縮し自身がスクロール境界になれる (移行前の手書きラッパと等価)。
 */
export const PageScrollArea = ({
  children,
}: PageScrollAreaProps): React.ReactElement => (
  <Box
    flexDirection="column"
    flex="1"
    display="flex"
    overflow="auto"
    minHeight="0"
  >
    {children}
  </Box>
)
